import * as React from "react";
import { useState, useEffect } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import Drawer from "components/common/Drawer";
import { Icon, IfPermitted } from "components/common";
import { Button } from "components/bootstrap";
import { Row } from "common/components";
import useGetPermissionsByScope from "hooks/useScopePermissions";
import EventProcedureDetailsView from "security-app/components/SecurityEvents/EventProcedures/EventProcedureDetailsView";
import EventProcedureModal from "../EventProcedureModal";
const Title = styled.div`
  text-overflow: ellipsis;
  overflow: hidden;
  line-height: 1.2;
`;
const RoundButton = styled(Button)`
  border-radius: 4px;
`;
function EventProcedureDetailsDrawer({ eventProcedure, onClose }) {
  const { t } = useTranslation("enterprise_security_events");
  const [show, setShow] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const { scopePermissions } = useGetPermissionsByScope(eventProcedure);
  useEffect(() => {
    setTimeout(() => setShow(true), 100);
  }, []);
  const onCloseEditModal = () => {
    setShowEditModal(false);
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    Drawer,
    {
      opened: show,
      onClose,
      size: "lg",
      position: "right",
      overlayProps: { zIndex: "1030" },
      title: /* @__PURE__ */ React.createElement(Row, { $align: "center", $justify: "space-between", $width: "100%" }, /* @__PURE__ */ React.createElement(Title, { title: eventProcedure.title || t("details_drawer.no_title") }, eventProcedure.title || /* @__PURE__ */ React.createElement("i", null, t("details_drawer.no_title"))), (scopePermissions == null ? void 0 : scopePermissions.is_mutable) && /* @__PURE__ */ React.createElement(IfPermitted, { permissions: [`event_procedures:edit:${eventProcedure.id}`] }, /* @__PURE__ */ React.createElement(RoundButton, { bsSize: "sm", onClick: () => setShowEditModal(true) }, /* @__PURE__ */ React.createElement(Row, { $align: "center", $gap: "xs" }, /* @__PURE__ */ React.createElement(Icon, { name: "edit_square" }), /* @__PURE__ */ React.createElement("span", null, t("details_drawer.edit"))))))
    },
    /* @__PURE__ */ React.createElement(EventProcedureDetailsView, { eventProcedure, withAssocEntities: true })
  ), showEditModal && /* @__PURE__ */ React.createElement(EventProcedureModal, { onClose: onCloseEditModal, eventProcedureId: eventProcedure.id }));
}
export default EventProcedureDetailsDrawer;
